// extracted by mini-css-extract-plugin
module.exports = {"root":"RegexRule_root__1EIXT","header":"RegexRule_header__3lyvC","visible":"RegexRule_visible__VZEgR","notVisible":"RegexRule_notVisible__29lJY"};